<app-header></app-header>
<div class="container">
	<div class="page-loader" *ngIf="loadershow">
		<img src="assets/images/uib-loading-500x500.gif" style="width: 100px">
	</div>

	<div class="row">
		<div class="col-md-3 sideNavBarStyle">
			<div class="sideNavBar">
				<mat-sidenav-container>
					<mat-sidenav #sidenav class="sideNav">
						<mat-nav-list>
							<p class="sideBarP1">
								<button style="white-space:nowrap;" type="button" class="btn btn-info" data-toggle="modal" data-target="#addConnectorModal">{{ 'Connector.AddConnector' | translate }}</button>
							</p>
							<p class="sideBarP2">{{ 'Connector.MyConnectors' | translate }}</p>
							<p *ngFor="let item of connectorList; let i = index" class="sidebar-content">
								<a [ngClass]="{'is-active': clickedItem == item.name}" mat-list-item (click)="viewConnectorDetails(item)">{{item.name}} </a>
							</p>
						</mat-nav-list>
					</mat-sidenav>
				</mat-sidenav-container>
			</div>
		</div>

		<div class="col-md-9">
			<div class="sideBarContent" *ngIf="connectorContent; else isConnectorContentEmpty">
				<div class="row">
					<div class="col-md-10 connectorNameDisplayStyle">
						<h1>{{ connectorContent.name }}</h1>
					</div>
					<div class="col-md-2 connectorNameDeleteStyle" *ngIf="!connectorContent.publishStatusButton && !connectorContent.updatepublishStatusButton">
						<i class="fa fa-trash-o fa-lg deleteIcon" aria-hidden="true" (click)="deleteConnector()"></i>
					</div>
				</div>
				<hr>
				<h2>{{ 'Application.KeyData' | translate }}</h2>
				<hr>
				<table class="table table-bordered dashboard-table">
					<tbody>
						<tr>
							<th>{{ 'Connector.connecorIdLabel' | translate }}</th>
							<td>{{ connectorContent.id }}</td>
						</tr>
						<tr>
							<th>{{ 'Connector.connecorIdentifierLabel' | translate }}</th>
							<td>{{ connectorContent.scheme }}</td>
						</tr>
						<tr>
							<th>{{ 'Connector.connectorStatus' | translate }}</th>
							<td><label
								*ngIf="connectorContent.private == true">{{ 'Connector.connectorUnpublished' | translate }}</label>
							<label
								*ngIf="connectorContent.private == false">{{ 'Connector.connectorPublished' | translate }}</label></td>
						</tr>
						<tr>
							<th>{{ 'Connector.connectorAccessKey' | translate }}</th>
							<td>{{ connectorContent.accessKey }}</td>
						</tr>
						<tr>
							<th>{{ 'Connector.connectorSecret' | translate }}</th>
							<td>{{ connectorContent.secret }}</td>
						</tr>
						<tr>
							<th>{{ 'Connector.connectorUsedBy' | translate }}</th>
							<td *ngIf="!usedByApplicationsList || usedByApplicationsList.length === 0">{{ connectorContent.UsedByApplications }} Applications</td>
							<td *ngIf="usedByApplicationsList && usedByApplicationsList.length > 0">
								<a class="a-class" data-toggle="modal" data-target="#viewApplicationDetails">{{ connectorContent.UsedByApplications }} Applications</a>
							</td>
						</tr>
					</tbody>
				</table>
				<h2>{{ 'Connector.connectorOptions' | translate }}</h2>
				<hr>
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.connectorIcon' | translate }}:</h4>
					</div>
					<div class="">
						<label for="uploadInput">
							<img alt="" *ngIf="(connectorContent.icon !== null && connectorContent.icon !== '') && imageUploaded == false"
								class="iconConnector" [src]="connectorContent.icon">
							<img alt="" *ngIf="((connectorContent.icon == null || connectorContent.icon == '') && imageUploaded == false)"
								class="iconConnector" src="assets/images/fileupload.png">
							<img alt="" *ngIf="previewUrl && imageUploaded == true" class="iconConnector" [src]="previewUrl">
						</label>
						<input id="uploadInput" type="file" name="displayImage" class="imageClass"
							(change)="uploadImage($event)">
							<i class="fa fa-pencil iconStyle" aria-hidden="true"  *ngIf="!((connectorContent.icon == null || connectorContent.icon == '') && imageUploaded == false)" (click)="file.click()" style="top: -10px !important;"><input id="uploadInput" type="file" name="displayImage" class="imageClass"
								(change)="uploadImage($event)" #file></i>
							<i class="fa fa-plus iconStyle" aria-hidden="true" *ngIf="((connectorContent.icon == null || connectorContent.icon == '') && imageUploaded == false)" (click)="file2.click()"><input id="uploadInput" type="file" name="displayImage" class="imageClass"
									(change)="uploadImage($event)" #file2></i>
									
					</div>
					
				</div>
				
						
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.connectorEndpoint' | translate }}:</h4>
					</div>
					<div class="row connectorIconLabel">
						<input type="text" class="form-control addConnectorInputs"
							[(ngModel)]="connectorContent.endPoint">
					</div>
					<span class="alert-error">{{ updateendpointRequiredError }}</span>
				</div>
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.webhookurl' | translate }}:</h4>
					</div>
					<div class="row connectorIconLabel">
						<input type="text" class="form-control addConnectorInputs" [(ngModel)]="connectorContent.webhookUrl">
					</div>
					<span class="alert-error">{{ updateWebHookUrlRequiredError }}</span>
				</div>
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.connectorType' | translate }}:</h4>
					</div>
					<div class="form-control" style="background: none !important;border:none !important;" *ngFor="let connector of connectorTypes;">
						<input type="radio" [(ngModel)]="connectorContent.type" id="{{connector.value}}" value="{{connector.value}}">
							&nbsp;{{connector.value}}
					</div>
					<!--<div class="row connectorIconLabel">
						<input type="text" class="form-control addConnectorInputs" [(ngModel)]="connectorContent.type">
					</div>-->
					<span class="alert-error">{{ updateConnectorTypeRequiredError }}</span>
				</div>
				<div class="listConnectorClass" *ngIf="connectorContent.type != 'IoT'">
					<table class="table table-bordered dashboard-table">
						<tbody>
							<tr>
								<th>
									<h4 style="margin-bottom:0px;"> 
										{{ 'Connector.connectorCapabilites' | translate }}
									</h4>
									<span class="alert-error">{{ connectorCapabilityRequiredError }}</span>
								</th>
							</tr>
							<tr>
								<td>
									<ul class="connectorListUl">
										<li class="connectorListLI" *ngFor="let cap of capabilities; let i = index">
											<div class="cap-checkbox"><input type="checkbox"
													[checked]="valueCheck(cap.name,connectorContent.capabilities)"
													(change)="checkedValueArray($event, cap)" id="{{cap.name+'recieve'}}"></div>
											<div class="cap-label"><label>{{cap.name}}</label></div>
											<div class="tooltip">
												<i class="fa fa-info-circle icon-info" aria-hidden="true"></i>
												<span class="tooltiptext">{{ cap.title }}</span>
											</div>
										</li>
									</ul>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="listConnectorClass" *ngIf="connectorContent.type == 'IoT'">
					<table class="table table-bordered dashboard-table">
						<tbody>
							<tr>
								<th>
									<h4 style="margin-bottom:0px;">{{ 'Connector.connectorDeviceCapability' | translate }}</h4>
								</th>
							</tr>
							<tr>
								<td>
									<ul class="connectorListUl">
										<li class="connectorListLI" *ngFor="let cap of deviceCapabilities; let i = index">
											<div class="cap-checkbox"><input type="checkbox"
													[checked]="valueCheckDevice(cap.name,connectorContent.deviceCapabilities)"
													(change)="checkedDeviceValueArray($event, cap)" id="{{cap.name+'recieve'}}">
											</div>
											<div class="cap-label">{{cap.name}}</div>
											<div class="tooltip">
												<i class="fa fa-info-circle icon-info" aria-hidden="true"></i>
												<span class="tooltiptext">{{ cap.title }}</span>
											</div>
										</li>
									</ul>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.connectorLimit' | translate }}:</h4>
					</div>
					<div class="charLimitClass">
						<strong>{{ 'Connector.characterLimitLabel' | translate }}</strong>
					</div>
					<div class="row connectorIconLabel">
						<input type="number" class="form-control addConnectorInputs"
							[(ngModel)]="connectorContent.capabilityLimits">
					</div>
				</div>
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.connectorTimeout' | translate }}:</h4>
					</div>
					<div class="row connectorIconLabel">
						<input type="number" class="form-control addConnectorInputs"
							[(ngModel)]="connectorContent.timeout">
					</div>
					<span class="alert-error">{{ updatetimeoutRequiredError }}</span>
				</div>
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.connectorClientId' | translate }}:</h4>
					</div>
					<div class="row connectorIconLabel">
						<input type="text" class="form-control addConnectorInputs"
							[(ngModel)]="connectorContent.clientId">
					</div>
					<span class="alert-error">{{ updateclientIdRequiredError }}</span>
				</div>
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.connectorClientSecret' | translate }}:</h4>
					</div>
					<div class="row connectorIconLabel">
						<input type="text" class="form-control addConnectorInputs"
							[(ngModel)]="connectorContent.clientSecret">
					</div>
					<span class="alert-error">{{ updateclientSecretRequiredError }}</span>
				</div>
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.connecorOptionalparams' | translate }}:</h4>
					</div>
					<div class="row optParams">
						<div class="col-md-3">
							{{ 'Common.Key' | translate }}
							<div class="row" *ngFor="let item of paramsArray;let l = count">
								<input type="text" class="form-control addConnectorParams" name="key"
									[(ngModel)]="item.key">
							</div>
						</div>
						<div class="col-md-3">
							{{ 'Common.Value' | translate }}
							<div class="row" *ngFor="let item of paramsArray; let l = count">
								<input type="text" class="form-control addConnectorParams" name="value"
									[(ngModel)]="item.value">
							</div>
						</div>
					</div>
				</div>
				<div class="listConnectorClass">
					<div class="row connectorIconLabel">
						<h4>{{ 'Connector.connectorPublickey' | translate }}:</h4>
					</div>
					<div class="row connectorIconLabel">
						<textarea class="form-control connectorDetailsKey" name="public_Key"
							[(ngModel)]="connectorContent.publicKey"></textarea>
					</div>
					<span class="alert-error">{{ updatepublicKeyRequiredError }}</span>
				</div>
				<div class="listConnectorClass">
					<button *ngIf="connectorContent.approvalstatusButton" type="button" class="btn btn-info"
						(click)="updateConnectorDetails()">{{ 'Connector.updateConnectorLabel' | translate }}</button>
					<button *ngIf="connectorContent.approvalstatusButton" type="button" class="btn btn-info"
						(click)="publishConnectorDetails()">
						{{ 'Connector.publishConnectorLabel' | translate }}</button>
					<button *ngIf="connectorContent.waitingReviewButton" type="button" class="btn btn-cancelPublish"
						(click)="cancelPublishRequest()">
						{{ 'Connector.waitingReviewButton' | translate }}</button>
					<button *ngIf="connectorContent.publishStatusButton" type="button" class="btn btn-info"
						(click)="updatePublish()">
						{{ 'Connector.publishStatusButton' | translate }}</button>
					<button *ngIf="connectorContent.updatepublishStatusButton" type="button" class="btn btn-info"
						(click)="cancelPublishUpdate()">
						{{ 'Connector.updatepublishStatusButton' | translate }}</button>
				</div>
			</div>
			<ng-template #isConnectorContentEmpty>
				<div class="isAppicatonContent ">
					<h1>{{ 'Common.GetStarted' | translate }}</h1>
					<hr>
					<p> {{ 'Connector.EmptyContent' | translate }} <br>
						{{ 'Connector.EmptyContent1' | translate }}
					</p>
				</div>
			</ng-template>
		</div>
	</div>
</div>
<app-footer></app-footer>

<!-- addConnector Modal -->
<div class="modal fade" role="dialog" id="addConnectorModal">
	<div class="modal-dialog modal-lg">
		<div class="modal-content modal-content-addconnector">
			<!-- Modal Header -->
			<div class="modal-header">
				<div><button type="button" class="close" (click)="onCloseModelHeader()" data-dismiss="modal">&times;</button></div>
				<div>
					<h4 class="modal-title d-inline">{{ 'Common.AddConnector' | translate }}: </h4>
					<h4 class="d-inline" [ngStyle]="{'color': tabName === 'Great Success!' ? '#5cb85c' : '#212529'}">
						{{ tabName }}
					</h4>
				</div>
			</div>

			<!-- Modal body -->
			<div class="modal-body addConnector-Modal">
				<div class="">
					<mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="tabChanged($event)">
						<mat-tab label="Endpoint">
							<div class="endpointList">
								<label>{{ 'Connector.endpointLabel' | translate}}</label>
								<input style="margin-left: 4px;" type="text" class="form-control addConnectorInputs" name="connectorEndpoint" [(ngModel)]="connectorEndpoint" placeholder="http://www.yourdomain.com" required>
								<span class="alert-error">{{ endpointRequiredError }}</span>
							</div>
						</mat-tab>
						<mat-tab label="Connector Type">
							<div class="connectorType">
								<label>{{ 'Connector.connectorType' | translate}} : </label>
								<div>
									<span class="alert-error">{{ connectorTypeRequiredError }}</span>
								</div>
								<div class="form-control" style="background: none !important;border:none !important;" *ngFor="let connector of connectorTypes;">
									<input type="radio" [(ngModel)]="selectedConnectorType" id="{{connector.value}}" value="{{connector.value}}" (change)="connectorTypeChange()">
									&nbsp;{{connector.value}}
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Capabilities">
							<div class="endpointList">
								<div>
									<label>{{ 'Connector.capabilityLabel' | translate}}</label>
								</div>
								<div>
									<span class="alert-error">{{ capabilityRequiredError }}</span>
								</div>
								<div *ngIf="selectedConnectorType !='IoT'">
									<div class="capList col-md-3" *ngFor="let cap of capabilities">
										<input style="/*margin-left: 4px;*/" name="{{ cap.name }}" type="checkbox" id="{{cap.name}}" (change)="onChangeCategory($event, cap)" [checked]="cap.checked">
										<label>{{ cap.name }}</label>
										<div class="tooltip">
											<i class="fa fa-info-circle icon-info" aria-hidden="true"></i>
											<span class="tooltiptext">{{ cap.title }}</span>
										</div>
									</div>
								</div>
								<div *ngIf="selectedConnectorType =='IoT'">
									<div class="capList col-md-3" *ngFor="let cap of deviceCapabilities" style="padding-right: 0px;">
										<input style="/*margin-left: 4px;*/" name="{{ cap.name }}" type="checkbox" id="{{cap.name}}" (change)="onChangeCategory($event, cap)"  [checked]="cap.checked">
										<label>{{ cap.name }}</label>
										<div class="tooltip">
											<i class="fa fa-info-circle icon-info" aria-hidden="true"></i>
											<span class="tooltiptext">{{ cap.title }}</span>
										</div>
									</div>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Timeout">
							<div class="endpointList">
								<label>{{ 'Connector.timeoutLabel' | translate}}</label>
								<input style="margin-left: 4px;" type="number" class="form-control addConnectorInputs" name="connectorTimeout"
									[(ngModel)]="connectorTimeout" placeholder="e.g.90" required>
								<span class="alert-error">{{ timeoutRequiredError }}</span>
							</div>
						</mat-tab>
						<mat-tab label="Name">
							<div class="endpointList">
								<label>{{ 'Connector.nameLabel' | translate}}</label>
								<div class="tooltip">
									<i class="fa fa-info-circle" aria-hidden="true"></i>
									<span class="tooltiptext">{{ 'Connector.nameTooltip' | translate}}</span>
								</div>
								<label>{{ 'Connector.identifierLabel' | translate}}</label>
								<input style="margin-left: 4px;" type="text" class="form-control addConnectorInputs identifierStyle" name="connectorName" [(ngModel)]="connectorName" placeholder="Name" required>
								<span class="alert-error">{{ connectorNameRequiredError }}</span>
								<input style="margin-left: 4px;" type="text" class="form-control addConnectorInputs identifierStyle" name="connectorIdentifier" [(ngModel)]="connectorIdentifier" placeholder="Identifier" required>
								<span class="alert-error">{{ connectorIdentifierRequiredError }}</span>
							</div>
						</mat-tab>
						<mat-tab label="oAuth">
							<label class="oAuthLabelStyle">{{ 'Connector.oAuthLabel' | translate}}</label>
							<div class="credentialDiv">
								<input style="margin-left: 4px;" type="text" class="form-control addConnectorInput" name="clientId" [(ngModel)]="clientId" placeholder="Client ID" required>
								<span>({{ 'Connector.appkeyInfo' | translate }})</span>
								<br>									
								<span class="alert-error">{{ clientIdRequiredError }}</span>
							</div>
							<div class="credentialDiv">
								<input style="margin-left: 4px;" type="text" class="form-control addConnectorInput" name="clientSecret" [(ngModel)]="clientSecret" placeholder="Client Secret" required>
								<span>({{ 'Connector.appsecretInfo' | translate }})</span>
								<br>								
								<span class="alert-error">{{ clientSecretRequiredError }}</span>
							</div>
						</mat-tab>
						<mat-tab label="Public Key">
							<div class="endpointList">
								<label>{{ 'Connector.publicKeyLabel' | translate}}</label>
								<textarea style="margin-left: 4px;" class="form-control addConnectorTextArea" name="publicKey" [(ngModel)]="publicKey"></textarea>
								<span class="alert-error">{{ publicKeyRequiredError }}</span>
							</div>
						</mat-tab>
						<mat-tab>
							<div  class="endpointList">
								<div style="margin:5px 55px">
									<p>{{ 'Connector.successMsg1' | translate }} <br>
										{{ 'Connector.successMsg2' | translate }} </p>
								</div>
								<div class="addAnCon">
									<a (click)="addAnotherConnector()" [ngStyle]="{'display':displayAddAnCon}">{{ 'Connector.addAnotherConnector'| translate}}</a>
									<button type="button" class="btn btn-info conNext" [ngStyle]="{'display':displayDone}" (click)="addConnectorDone()">{{ 'Common.done' | translate }}</button>
								</div>
							</div>
						</mat-tab>
					</mat-tab-group>
					<div class="row tabGroupBtn">
						<button type="button" class="reset-btn-login" [disabled]="backButtonDisable" [ngStyle]="{'display':displayPrev}" (click)="previousStep()">{{ 'Common.Back' | translate }}</button>
						<button type="button" class="btn btn-info conNext" [disabled]="nextButtonDisable" [ngStyle]="{'display':displayNext}" (click)="nextStep()">{{ 'Common.Next' | translate }}</button>
						<button type="button" class="btn btn-info conNext" [ngStyle]="{'display':displaySubmit}" (click)="addConnectorDetails()">{{ 'Common.Submit' | translate }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- MODAL SECTION -->
<!-- viewApplicationDetails Modal -->
<div class="modal fade" role="dialog" id="viewApplicationDetails">
	<div class="modal-dialog">
		<div class="modal-content modal-content-webhook">
			<!-- Modal Header -->
			<div class="modal-header">
				<div>
					<h4 class="modal-title">{{ 'Connector.connectorUsedBy' | translate }} Application Details</h4>
				</div>
				<div><button type="button" class="close closeButtonWebhook" data-dismiss="modal">&times;</button></div>
			</div>

			<!-- Modal body -->
			<div class="modal-body" style="background:none !important;">
				<div class="row">
					<div class="table-responsive movie-table" style="padding: 2% !important;">
            			<table class="table table-striped table-bordered">
                  			<thead>
								<tr class= "movie-table-head">
									<th>{{ 'Application Name' | translate }}</th>
									<th>{{ 'Login Name' | translate }}</th>
								</tr>
              				</thead>   
              				<tbody>
								<tr *ngFor="let item of usedByApplicationsList;" style="text-align: center;">
									<td>{{ item.name | translate }}</td>
									<td>{{ item.developerEmail | translate }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<!-- Modal footer -->
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">{{ 'Common.Cancel' | translate }}</button>
			</div>
		</div>
	</div>
</div>